/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/ErrorPage/theme';

export const ErrorPageTheme = theme;
